import { create } from "zustand";

const useActiveTabStore = create((set) => ({
    //activeTab: 'Home',
    //activeTab: 'About',
    //activeTab: 'Projects',
    //activeTab: 'Skills',
    //activeTab: 'Contact',
    setActiveTab: (tab) => set({ activeTab: tab }),
    //setMainContentTab: (tab) => set({ mainContentTab: tab }),
}))
export default useActiveTabStore
